import { environment } from 'src/environments/environment';
import { SweetAlertIcon } from 'sweetalert2';

// CONSTANTS
export const GENERAL_CONSTANTS = {
    OK_RESPONSE_CODE: '0000',
    UNAUTHORIZED_CODE: '0001',
    BAD_REQUEST_CODE: '0002',
    INVALID_TOKEN: 401,
    CREATED_RESPONSE_CODE: 201,
    // PATTERN TO INITIAL SIZE FOR MOBILE DEVICE SCREENS
    SCREEN_SIZE_MOBILE_DEVICE: 768,
    PRINT_VOUCHER_TITLE: 'Recibo_de_pago: ',
    RETRY_PAYMENT: 'Reintentar Pago',
    PHONE_PREFIX_COLOMBIA: '+57',
    PHONE_PREFIX_COLOMBIA_3DS: '57',
    PRIORITY: 'priority',
    GENERAL_ALERT: `Ha ocurrido un error interno, por favor ponte en contacto con ${environment.support_email}`,
    NUMBER_ZERO: 0,
    STRING_ZERO: '0',
    PSE_TRANSACTION_ERROR_ALERT: 'Parece que hay un error en la transacción, comunicate con el comercio',
    PAYVALIDA_FF_PLATFORM: 'payvalida',
    TRANSACTION_ID: 'transactionId',
    HTTPS_PROTOCOL: 'https://',
    VALID_STRING: 'VALID',
    BEVALIDA_STRING: 'BEVALIDA',
    PSE_STRING: 'PSE',
    OK_DEFAULT_STRING: 'OK',
    BNPL_STRING: 'BNPL',
    IS_PSE_FAILED_TRX_RETURNING_ID: 'isFailedBnplTransaction',
    IS_PSE_FAILED_TRX_RETURNING_REFERENCE: 'isFailedBnplTransactionReference',
    IS_CDC_FAILED_TRX_RETURNING: 'isCdcFailedTrx',
    IS_CDC_FAILED_TRX_RETURNING_REF: 'isCdcFailedTrxRef',
    POPUP_BNPL_ORIGIN: 'BNPL',
    TIME_OUT_TO_RETRY: 30,

    MOBILE_DEVICES: {
        android: /Android/i,
        webOs: /webOS/i,
        iPhone: /iPhone/i,
        iPad: /iPad/i,
        iPod: /iPod/i,
    },
    // PATTERN
    PATTERN: {
        ONLY_STRING: '^[A-Za-zñÑáéíóúÁÉÍÓÚ. ]*$',
        EMAIL: '^[a-z0-9._%-]+@[a-z0-9.-]+\\.[a-z]{2,4}$',
        ONLY_NUMBER: '^[0-9]*$',
        // Expression to validate strings containing only letters and spaces in between
        ONLY_STRING_WHITHOUT_SPACES: /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ]+([ \t]+[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ]+)*$/,
        // Expression to validate that the e-mail does not contain special characters or spaces
        EMAIL_VALIDATOR: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
        ADDRESS: '^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ #-.,]*$',
    },

    // TEMPLATES TO CUSTOM BUTTONS
    TEMPLATES: {
        DEPOSIT: 'deposit',
        CASH: 'cash',
        TRANSFER: 'transfer',
        BNPL: 'bnpl',
        CLAROPAY: 'claroPay',
        ACH: 'ach',
        WALLET_PSE: 'walletPse',
        QR: 'qr',
        BNPL_BANCOLOMBIA: 'bancolombia',
        SPLIT: 'split',
        DAVIPLATA_NATIVE: 'daviplataNative',
        SINPE_MOVIL: 'sinpeMovil',
        CONSUMER_CREDIT: 'cdcBancolombia',
        DEUNA: 'deuna',
        PUNTOS_COLOMBIA: 'puntosColombia',
        TRANSFIYA: 'transfiya',
    },
    // RESPONSE ERROR CODES
    RESPONSE_GENERAL_ERROR_CODES: {
        ERROR_LAMBDA_CONF_PROCESS: '0001',
        GENERIC_PROCESS_ERROR: '0011',
        MALFORMED_REQUEST: '0002',
        INVALID_REQUEST: '0003',
        INVALID_TOKEN: '0004',
        RATE_LIMIT: 429,
    },
    // RESPONSE ERROR CODES CLARO PAY
    RESPONSE_ERROR_CLARO_PLAY: {
        INVALID_ASSOCIATED_ORDER: '0005',
        PAYMENT_NOT_SUPPORTED: '0006',
        INVALID_ORDER_AMOUNT: '0007',
        GENERAL_ERROR: 'Error al crear el link de pago',
        ERROR_REDIRECT_URL: 'Ocurrió un error creando la redirección de la url de retorno del comercio',
        ERROR_CREATING_QR_CODE: 'Ocurrió un error al genear el código QR',
        ERROR_CHECK_ORDER_STATUS: 'Ocurrió un error al consultar el estado de la orden',
        // TRANSACTION_STATUS
        TRANSACTION_STATUS: {
            CANCELLED: 'cancelled',
            CHARGE_FAILED: 'charge_failed',
            CREATED: 'created',
            DELIVERED: 'delivered',
            EXPIRED: 'expired',
            REVERTED: 'reverted',
            CHARGE_IN_PROGRESS: 'charge_in_progress',
            PAID: 'paid',
            NULL: 'null',
        },
    },
    // TRANSACTION_MESSAGE_STATUS
    TRANSACTION_MESSAGE_STATUS: {
        PENDING: {
            TITLE: 'pendiente',
            ICON: 'spinner',
            MESSAGE_RESPONSE: 'Comunícate con el comercio para comprobar el estado de tu transacción',
        },
        APROVED: {
            TITLE: 'exitoso',
            ICON: 'check-circle',
            MESSAGE_RESPONSE: 'Enviamos una notificación de tu pago al comercio.\nSi tienes alguna duda, ponte en contacto con:',
        },
        FAILED: {
            TITLE: 'incorrecto',
            ICON: 'exclamation-triangle',
            MESSAGE_RESPONSE: 'Comunícate con el comercio para comprobar el estado de tu transacción',
        },
        EXPIRED: {
            TITLE: 'expirado',
            ICON: 'exclamation-triangle',
            MESSAGE_RESPONSE: 'Si no pudiste terminar tu transacción puedes dar clic en el botón REINTENTAR PAGO',
        },
    },

    TRANSACTION_LOADING_STATUS_MESSAGES: {
        PROCESSING_TRANSACTION: 'Procesando transacción',
        CONTACTING_BANK: 'Contactando a tu banco',
        WAITING_BANK_RESPONSE: 'Esperando respuesta de tu banco',
        PROCESSING_BANK_RESPONSE: 'Procesando respuesta de tu banco'
    },

    PAYMENT_METHOD_CODES: {
        BNPL: 2093,
    },

    HTTP_RESPONSE_MESSAGES: {
        UNAUTHORIZED: 'unauthorized',
        BAD_REQUEST: 'bad request',
        OK: 'OK',
        INVALID_TOKEN: 'invalid token',
    },

    SPLIT_ORDERS_RESPONSE: {
        INVALID_TOKEN: '0002',
        INTERNAL_ERROR: '0003',
        NO_ORDERS_FOUND: '0004',
    },

    DAVIPLATA_RESPONSE: {
        INVALID_TOKEN: '0002',
        INVALID_ORDER: '0003',
        INTERNAL_ERROR: '0004',
        INVALID_ACCOUNT: '0005',
        INSUFICCIENT_BALANCE: '0006',
        TRANSACTION_NOT_FOUND: '0007',
        INVALID_OTP_CODE: '0008',
        ERROR_CONFIRM_TRANSACTION: '0009',

        RESPONSE_MESSAGES: {
            INVALID_ACCOUNT: 'Número de documento no asociado a una cuenta Daviplata',
            INSUFICCIENT_BALANCE: 'Saldo insuficiente para completar el pago',
            TRANSACTION_NOT_FOUND: 'Transacción no encontrada',
            INVALID_OTP: 'Código OTP inválido',
            ERROR_CONFIRM_TRANSACTION: 'Error confirmando la transacción',
            ERROR_LIMIT_TRANSACTIONS: 'No es posible procesar tu transacción en este momento, por favor intenta más tarde',
        },
    },

    // TEST MERCHANTS
    TEST_MERCHANTS: {
        KUANTO: 'kuanto',
        BRANCHOS: 'branchos',
    }
};

export const FLAGS_NAME = {
    SUB_MENU_CR: 'sub_menu_flag',
    UNIQUE_LINK: 'getUniqueLink_merchant',
    REDEBAN_CREDIT_CARDS: 'checkout_FF',
    BNPL_CLIENTS: 'bnpl_clients',
    DAVIPLATA_USER_FIELDS_ON_OTP_VIEW: 'daviplata_user_fields_on_otp_view',
    LAFISE_INTEGRATION: 'lafise-commercail-network-ff',
    LAFISE_FF_PARAMETER: 'lafise-integration',
    THREEDS_NEW_FLOW: 'threeds-new-flow-FF',
    THREEDS_VALIDATOR: 'threeDsValidatorFF',
    NIUBIZ_INTEGRATION: 'niubizIntegrationFF',
    FIX_AUTOCOMPLETE_TOKEN: 'fixAutocompleteTokenPersonalInfoFF',
    MOVII_INTEGRATION: 'moviiIntegrationFF',
    FIX_3DS_VALIDATOR_METHOD: 'threeDsValidatorFixFF',
    DOWNLOAD_INSTRUCTIONS_BUTTON: 'downloadInstructionButtonFF',
    PUNTOS_HEY_PDF_DOWNLOAD: 'ptosHeyPdfDownloadFF',
    VALIDATOR_ERROR_3DS_FIX: 'validatorErrorFixFF',
    RECOMMENDATIONS_BANNER_FF: 'recommendationBannersForPaymentMethodsFF',
    BANNER_RECOMMENDATION_UI_FIX: 'bannerRecommedationUiFixFF',
    SUB_MENU_GU_PARAMETER: 'subMenuGu',
    SUB_MENU_GU_FLAG: 'sub-menu-gu-ff',
    LAFISE_BANKS_PAYMENT_METHOD: 'lafiseBanksPaymentMethodFF',
    PCO_PAY_METHOD_FF: 'ptosColFF',
    ENABLE_PSE_POPUP: 'enablePsePopup',
    ENABLE_BNPL_POPUP: 'enableBnplPopup',
    PSE_TOKEN_INFO_FF: 'pse-tokenInfo-ff',
    PSE_CHANGE_DOC_TYPE_PERSON_TYPE_FF: 'pseChangeDocTypePersonTypeFf',
    FIX_AUTOCOMPLETE_TOKEN_PERSONAL_INFO: 'fixAutocompleteTokenPersonalInfoFF',
    FIX_ERROR_ALERT_PSE_FF: 'fixErrorAlertPseFF',
    ENABLE_PCO_POINTS_ACUMM_FF: 'enablePcoPointsAcummFF',
    ACUMM_PCO_BY_MERCHANT: 'acummulationByMerchantPcoFF',
    ENABLE_EXTRA_CARDHOLDER_DATA: 'enableExtraCardholderData',
    WALLETS_AUTOCOMPLETE_FF: 'walletsAutoCompleteFF',
    CHECKOUT_RETURN_FF: 'checkoutReturnFF',
    DEUNA_CHECKOUT_FF: 'deunaCheckoutFF',
    MOVII_AMEX_FRANCHISE_FF: 'moviiAmexFranchiseFF',
    CDC_TRX_FAILED_CHECKOUT_RETURN_FF: 'cDcCheckoutReturnFF',
    ENABLE_CHECKOUT_EMBEBED_TC_FORM_FF: 'enableCheckoutEmbebedTcFormFF',
    ENABLE_SHOPIFY_THANK_YOU_PAGE_FF: 'enableShopifyThankYouPageFf',
    YAPE_NEW_QR_STEPS_FF: 'yapeNewQrStepsCheckoutFF',
    WAIT_3_SECS_FOR_NOTIFICATIONS: 'wait3SecsForOrderNotificationsFf',
    WAIT_7_SECS_FOR_NOTIFICATIONS: 'wait7SecsForOrderNotificationsFf',
    WAIT_15_SECS_FOR_NOTIFICATIONS: 'wait15SecsForOrderNotificationsFf',
    NIUBIZ_AMEX_FRANCHISE_FF: 'niubizAmexFranchiseFF',
    PAYVALIDA_WALLET_EMBEBED: 'payvalidaWalletEmbebedFF',
    ENABLE_KOUNT_INTEGRATION: 'kountMerchantValidation',
    TRANSFER_AND_DEPOSITS_AUTOCOMPLETE_FF: 'transferAndDepositsAutoCompleteFF',
    TRANS_STATUS_A_TO_KOUNT: 'transStatusAToKount',
    AUTO_EXPOSE_TC_FORM_FF: 'autoExposeTcFormFF',
    ENABLE_CHECKOUT_EMBEBED_API_PAY_IN_FORM_FF: 'embebedApiPayinFormFF',
    ENABLE_SENTRY_FF: 'enableSentryFF',
    PAYVALIDA_WALLET_EMBEBED_IN_TC_FORM: 'payvalidaWalletEmbebedInTcFormFF',
    CHANGE_DAVIPLATA_OTP_MSG: 'checkoutChangeDaviplataOtpMsg',
};

export const VALIDATIONS_CONFIG_LIST = {
    CLEARSALE: '6',
    NETCETERA: '7',
};

export const ORDER_STATES = {
    BEVALIDA_APPROVED: 'APPROVED',
    APPROVED: 'APROBADA',
    PENDING: 'PENDIENTE',
    REJECTED: 'RECHAZADA',
    FAILED: 'FALLIDA',
};

export const BUYER_INFORMATION = {
    RESPONSE_CODES: {
        OK_RESPONSE_CODE: '0000',
        PROCESS_PAYMENT: '0006',
    },
};

export const CONSUMER_CREDIT = {
    RESPONSE_CODES: {
        INVALID_REQUEST: '0004',
        INELEGIBLE_CLIENT: '0005',
        AMOUNT_TO_LOW: '0006',
    },
    RESPONSE_MESSAGES: {
        QUOTE_NOT_AVAILABLE: `Actualmente no cuentas con un cupo disponible para realizar un préstamo y aprobar tu compra. Para mayor información comunícate con la línea Bancolombia al teléfono ${environment.bancolombia_phone}`,
        TRANSACTION_NOT_APPROVED: `No pudimos procesar tu transacción, para mayor información comunícate con ${environment.info_email_co} o valida la información ingresada y reintenta la transacción.`,
        INVALID_AMOUNT: `Monto inválido`,
        STANDARD_ERROR_MESSAGE: 'Cupo en Bancolombia no disponible o error por falla técnica'
    },
};

export const TYPE_CLIENTS = [
    {
        value: 'N',
        name: 'Persona Natural',
    },
    {
        value: 'J',
        name: 'Persona Jurídica',
    },
];

export const API_V4_RESPONSE_NETWORK_CODES = {
    APROVED: '0000',
    REJECTED: '0001',
    WRONG_REQUEST: '0010',
    INVALID_REQUEST: '0011',
    INVALID_PAYMENT: '0012',
    CONSULT_CASHIN_ERROR: '0013',
    ANTI_FRAUD_ERROR: '0014',
    ANTI_FRAUD_ALERT: '0015',
    REGISTER_CASHIN_ERROR: '0016',
    PROCESS_LAFISE_TRANSACTION_ERROR: '0017',
};

export const API_V4_ERROR_RESPONSE_NETWORK_CODES = {
    WRONG_REQUEST: '0010',
    INVALID_REQUEST: '0011',
    INVALID_PAYMENT: '0012',
    CONSULT_CASHIN_ERROR: '0013',
    ANTI_FRAUD_ERROR: '0014',
    ANTI_FRAUD_ALERT: '0015',
    REGISTER_CASHIN_ERROR: '0016',
    PROCESS_TRANSACTION_ERROR: '0017',
    VALIDATE_3DS_ERROR: '0018',
};

export const THREEDS_INFO = {
    URL_EXISTS: 'Y',
    URL_NOT_EXISTS: 'U',
};

export const PAYVALIDA_SDK_CONSTANTS = { PAYVALIDA_SDK_WINDOW_OBJECT: 'payvalida_sdk' };

export const THREEDS_IFRAME_PARAMETERS = {
    IFRAME_CONTAINER: 'threeDSMethodIFrameContainer',
    REQ_05: 'threeDSCReq05',
    WEB_SDK: 'nca3DSWebSDK',
    ZERO_TWO: '02',
    FRAME_CONTAINER: 'frameContainer',
    IFRAME_DIALOG_WIDTH: '450px',
    IFRAME_DIALOG_HEIGHT: '550px',
};

export const COMMERCIAL_NETWORKS_CATEGORIES = {
    CASH_BANK_DEPOSIT: '1',
    CASH: '3',
    CREDIT_CARD: '4',
    DEPOSIT: '5',
    WALLET: '6',
};

export const WALLET_COUNTRY_CODES = {
    BEVALIDA_348_PERU: 520,
    BEVALIDA_345_ECU: 510,
    BEVALIDA_343_COL: 470,
    BEVALIDA_314_CR: 490,
    BEVALIDA_347_GU: 2200,
};

export const BANNER_MESSAGES = {
    RECOMMENDATION: 'RECOMENDACIÓN: ',
    CASH_RECOMMENDATION: 'Regístrate en Payválida Wallet y recarga efectivo para realizar pagos sin salir de casa.  Descarga la app desde ',
    DEPOSIT_RECOMENDATION: 'Regístrate en Payválida Wallet para registrar tus depósitos sin salir de casa.  Descarga la APP desde ',
    APP_STORE: 'APP Store (IOS)',
    PLAY_STORE: 'Play Store (Android)',
    OR: ' o ',
};

export const CASH_PDF_MESSAGES = {
    ERROR: 'Ocurrió un error al generar el documento PDF',
    CASH_PDF_NAME_FILE: 'instructivo-pago-efectivo'
};

export const VALID_IMG_FORMATS = ['jpg', 'jpeg', 'png'];

export const HTTP_STATUS_RESPONSE_CODES = {
    UNAUTHORIZED: '401',
};

export const AUTOCOMPLETE_METHOD_PAY_TYPES = {
    PSE: 1,
    TC: 2,
    CONSUMER_CREDIT: 3,
    PUNTOS_COLOMBIA: 4,
    WALLETS: 5,
    PSE_WALLETS: 6,
    DAVIPLATA_NATIVE: 7,
    DEUNA: 8,
    DEPOSITS_AND_TRANSFERS: 9
};

export const AUTOCOMPLETE_FORM_CONTROLS = {
    TITULAR_NAME: 'titularsName',
    DOCUMENT_TYPE: 'documenType',
    DOCUMENT_NUMBER: 'documentNumber',
    BILL_ADDRESS_LINE_1: 'billAddrLine1',
    NAME: 'name',
    LAST_NAME_TC: 'lastname',
    LAST_NAME_PSE: 'lastName',
    TYPE_DI: 'typeDI',
    DI: 'di',
    CELLPHONE: 'cellPhone',
    EMAIL: 'email',
    ADDRESS: 'address',
    COUNTRY: 'country',
    DOCUMENT_TYPE_2: 'documentType',
};

export const DAVIPLATA_NATIVE_OTP_CODE_LENGTH = {
    MIN_MAX: 6,
};

export const ALERT_ICON_CONSTANTS: {
    ERROR: SweetAlertIcon;
    SUCCESS: SweetAlertIcon;
    WARNING: SweetAlertIcon;
} = {
    ERROR: 'error',
    SUCCESS: 'success',
    WARNING: 'warning',
};

export const PCOL_TRANSACTION_KEYS = {
    PCOCL_TRANSACION_ID_PARAM: 'pcoExtTransactionID',
    PCOCL_TRANSACION_OBJECT_KEY: 'pColTransaction',
    PCOCL_TRANSACION_ID_KEY: 'pcoTransactionId',
    PCO_NATURAL_DOC: '2',
    PCO_LEGAL_DOC: '5',
    PCO_OTHER_TYPE_DOC: '3',
    PCO_INFO_ACUMMULATE_POINTS: 'pcoInfoAccumulatePoints',
}

export const PCO_NETWORK_CODES = { PCO_NETWORK_CODE: 2190, PCO_SPLIT_NETWORK_CODE: 2191 }

export const API_PATHS = {
    creditCardForm: '/TcFormView',
    transfiyaForm: '/TransfiyaFormView',
    apiPayInForm: '/ApiPayInFormView',
}

export const FLUTTER_POST_MESSAGE_TYPES = {
    IS_LOADING: 'isLoading',
    FORM_READY: 'formReady',
    ERROR: 'error',
    CONTENT_SIZE: 'contentSize',
    STATUS_CHANGE: 'statusChange',
    SCROLL: 'scroll',
    COMPLETE: 'complete',
};

export const FLUTTER_POST_MESSAGE_TO_SEND = {
    SET_USER_INFORMATION: 'setUserInformation',
    LOAD_WEB_SCRIPT: 'loadWebScript',
}

export const FLUTTER_TC_FORM_STATUS_TYPES = {
    OTP_CHALLENGE_REQUIRED: 'OTP_CHALLENGE_REQUIRED',
    FAILED: 'FAILED',
    REJECTED: 'REJECTED',
    INIT_KOUNT_VALIDATION: 'INIT_KOUNT_VALIDATION',
    KOUNT_VALIDATION_SUCCESS: 'KOUNT_VALIDATION_SUCCESS',
    ANTI_FRAUD_VALIDATED: 'ANTIFRAUD_VALIDATED',
    ANTI_FRAUD_FAILED: 'ANTIFRAUD_FAILED',
    APPROVED: 'APPROVED',
}

export const FLUTTER_STATUS_TYPES = FLUTTER_TC_FORM_STATUS_TYPES;


export const debugLog = (message: any) => {
    if (environment.production) return;

    console.log(message);
};


export const POP_UP_EXTERNAL_RESPONSES = {

    BNPL_COMPLETED: 'BNPL_COMPLETED',
    DOMAIN_NOT_ALLOWED: 'NOT_ALLOWED',

}


export const COUNTRY_CODES = {
    COLOMBIA: 343,
    PERU: 348,
    ECUADOR: 345,
    COSTARICA: 314,
    GUATEMALA: 347,
}

export const TRANSFIYA_TRANSFER_PARAMS = { TRANSFER_ID: 'transfer_ID', TOKEN: 'token'}

export const FLUTTER_API_PAY_IN_STATUS = { ORDER_ALREADY_PAID: 'ORDER_ALREADY_PAID', FAILED: 'FAILED', PENDING_EXTERNAL_PAYMENT_FLOW: 'PENDING_EXTERNAL_PAYMENT_FLOW', SUCCESS: 'SUCCESSFUL' }

export const API_PAY_IN_STATUS_TITLES = { FAILED: 'failed-pay-title', SUCCESS: 'success-Pay-Title' }

export const API_PAY_IN_VOUCHER_CONSTANTS = { DATE_FORMAT: 'DD/MM/YYYY', HEAD: 'HEAD' }


export const TRANSFIYA_ORDER_STATUS = {
    PENDING: 'PENDING',
    CREATED: 'CREATED',
    ACCEPTED: 'ACCEPTED',
    COMPLETED: 'COMPLETED',
    REJECTED: 'REJECTED',
    ERROR: 'ERROR',
    INITIATED: 'INITIATED'
}

export const TRANSFIYA_TIME_TO_REQUEST_AGAIN = 10;

// 300 = 5 minutes
export const TRANSFIYA_ATTEMPT_TIME_LIMIT = 300;